let _ = require('lodash');
let computed = require('../computed/account/user-form');
const computedIndex = require('../computed/auth/index');

function setUserTypeRadio (userType, formPath, state) {
    let userTypeRadio = {};
    userTypeRadio[userType.toString()] = true;
    state.set(formPath.concat(['userTypeRadio']), userTypeRadio);
    computedIndex.computeCountryDropdown(state, ['account', 'userForm']);
}

function initUserForm (user, state) {
    state.unset(['account', 'userForm', 'isError']);
    state.unset(['account', 'userForm', 'error']);
    state.set(['account', 'userForm', 'original'], Object.assign({}, user));
    state.set(['account', 'userForm', 'form'], Object.assign({}, user));
    setUserTypeRadio(user.userType, ['account', 'userForm'], state);
    if (user.userType === 1 && user.countryId === 1) {
        state.set(['account', 'userForm', 'form', 'inn12'], user.inn);
    } else if (user.userType === 2) {
        switch (user.countryId) {
            case 1:
                state.set(['account', 'userForm', 'form', 'inn10'], user.inn);
                break;
            case 4:
                state.set(['account', 'userForm', 'form', 'bin'], user.inn);
                break;
            default:
                break;
        }
    } else if (user.userType === 3) {
        switch (user.countryId) {
            case 1:
                state.set(['account', 'userForm', 'form', 'inn12'], user.inn);
                break;
            case 4:
                state.set(['account', 'userForm', 'form', 'bin'], user.inn);
                break;
            default:
                break;
        }
    }
}

module.exports = {
    setComputedFields (args, state) {
        computed.saveButton(state);
        computed.cancelButton(state);
        computed.isUserTypeSelectEnabled(state);
    },

    getCurrentUserData (args, state, output) {
        let user = state.get(['user']);

        output.success({ user });
    },

    setDefaultCountry ({ user }) {
        if (!user.countryId) {
            user.countryId = 1;
        }
    },

    initUserForm ({ user }, state) {
        initUserForm(user, state);
    },

    resetUserForm (args, state) {
        let user = state.get(['account', 'userForm', 'original']);
        initUserForm(user, state)
    },

    updateUserInfo (args, state, output, { locator, context }) {
        let Api = locator.resolve('api');

        let form = state.get(['account', 'userForm', 'form']);

        let requiredFields = ['city', 'firstName', 'lastName', 'middleName', 'phone', 'userType', 'countryId',
            'legalAddress'];
        let inn;
        if (form.userType === 1 && form.countryId === 1) {
            inn = form.inn12;
        } else if (form.userType === 2) {
            requiredFields = requiredFields.concat(['organization', 'kpp']);
            switch (form.countryId) {
                case 1:
                    inn = form.inn10;
                    break;
                case 4:
                    inn = form.bin;
                    break;
                default:
                    break;
            }
        } else if (form.userType === 3) {
            requiredFields = requiredFields.concat(['organization', 'legalAddress']);
            switch (form.countryId) {
                case 1:
                    inn = form.inn12;
                    break;
                case 4:
                    inn = form.bin;
                    break;
                default:
                    break;
            }
        }

        let data = _.pick(form, requiredFields);
        data.inn = inn;
        let userId = form.id;

        let request = Api.updateUserInfo(context, locator, { userId, data });

        request
            .then((response) => {
                let code = _.get(response, 'status.code');

                if (code === 200) {
                    output.success({
                        user: _.get(response, 'content')
                    });
                    return;
                }

                output.error({ error: code });
            })
            .catch((error) => {
                output.error({ error });
            });
    },

    selectUserType (formPath) {
        return function ({ key }, state) {
            state.set(formPath.concat(['form', 'userType']), Number(key));
            setUserTypeRadio(Number(key), formPath, state);
        };
    },

    initUserType (formPath) {
        return function (args, state) {
            state.set(formPath.concat(['form', 'userType']), 1);
            setUserTypeRadio(1, formPath, state);
        };
    },
};



// WEBPACK FOOTER //
// ./actions/account/user-form.js